import React, { useEffect, useState } from "react";
import api from "../api";

export default function AdminEmployeeWages() {
  const [loads, setLoads] = useState([]);
  const [loading, setLoading] = useState(false);

  const fetchLoads = async () => {
    try {
      setLoading(true);
      const r = await api.get("/admin/payroll-loads"); // admin sees all
      setLoads(r.data);
    } catch (err) {
      alert("Failed to fetch payroll data");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchLoads();
  }, []);

  const getTotalWages = (assignments = []) =>
    assignments.reduce((sum, a) => sum + (Number(a.pay) || 0), 0);

  return (
    <div className="container mt-4">
      <h2 className="mb-4">Employee Wages (Admin)</h2>

      {loading && <p>Loading payroll...</p>}

      {!loading && loads.length === 0 && (
        <div className="alert alert-info">No payroll data found</div>
      )}

      {loads.map((load) => {
        const totalWages = getTotalWages(load.assignments || []);

        return (
          <div key={load.id} className="card mb-4 shadow-sm">
            {/* LOAD HEADER */}
            <div className="card-header bg-dark text-white">
              <strong>PO:</strong> {load.po_number || "—"} |{" "}
              <strong>Product:</strong> {load.productType?.name || "—"} |{" "}
              <strong>Date:</strong> {load.date}
            </div>

            <div className="card-body">
              {/* EMPLOYEE WAGE TABLE */}
              {load.assignments && load.assignments.length ? (
                <table className="table table-sm table-bordered">
                  <thead className="table-secondary">
                    <tr>
                      <th>Employee</th>
                      <th>Clock In</th>
                      <th>Clock Out</th>
                      <th>Hours</th>
                      <th>Wage ($)</th>
                    </tr>
                  </thead>
                  <tbody>
                    {load.assignments.map((a) => (
                      <tr key={a.id}>
                        <td>{a.employee?.user?.name || "—"}</td>
                        <td>
                          {a.clock_in
                            ? new Date(a.clock_in).toLocaleString()
                            : "—"}
                        </td>
                        <td>
                          {a.clock_out
                            ? new Date(a.clock_out).toLocaleString()
                            : "—"}
                        </td>
                        <td>{a.hours_worked ?? "—"}</td>
                        <td>
                          <strong>$ {a.pay ?? 0}</strong>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              ) : (
                <p className="text-muted">No employees assigned</p>
              )}

              {/* LOAD TOTAL PAYROLL */}
              <div className="alert alert-warning mt-3">
                <strong>Total Employee Wages:</strong> $ {totalWages.toFixed(2)}
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
}
